<template>
	<contentBox>
		<parcel v-bind:id="id" v-bind:tab="tab"/>
	</contentBox>
</template>

<script>

import parcel from './parcel';
import contentBox from '../content';

export default {
	name: 'parcel-page',

	components:{
		contentBox,
		parcel,
	},

	props:{
		tab: String,
		id: Number,
	},
}

</script>


// WEBPACK FOOTER //
// src/components/parcel/parcel-page.vue